module.exports = __webpack_public_path__ + "img/circle-radiation.d80207dd.svg";